import React, { useMemo } from 'react';
import { getAttributes, isStructTreeNode, isStructTreeNodeWithOnlyContentChild } from "./shared/structTreeUtils.js";
export default function StructTreeItem(_ref) {
  var className = _ref.className,
    node = _ref.node;
  var attributes = useMemo(function () {
    return getAttributes(node);
  }, [node]);
  var children = useMemo(function () {
    if (!isStructTreeNode(node)) {
      return null;
    }
    if (isStructTreeNodeWithOnlyContentChild(node)) {
      return null;
    }
    return node.children.map(function (child, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(StructTreeItem, {
          key: index,
          node: child
        })
      );
    });
  }, [node]);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    className: className
  }, attributes), children);
}